export default "__VITE_ASSET__cd27c6b0__"